import { render, staticRenderFns } from "./CivilInsolvency.vue?vue&type=template&id=5ece06df&scoped=true&"
import script from "./CivilInsolvency.vue?vue&type=script&lang=js&"
export * from "./CivilInsolvency.vue?vue&type=script&lang=js&"
import style0 from "./CivilInsolvency.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CivilInsolvency.vue?vue&type=style&index=1&id=5ece06df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ece06df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
